@if (userExists) {
  <div class="flex justify-center items-center h-screen">
    <div class="x-card x-card_size_m x-white w-3/4">
      <h3 class="x-card__title">
        {{ 'core.no_permission.title' | translate }}
      </h3>
      <div class="x-card__paragraph">
        {{ 'core.no_permission.message' | translate }}
        <p class="mt-2">
          {{ 'core.no_permission.you_can_also' | translate }}
          <button
            appearance="flat"
            tuiButton
            type="button"
            (click)="logout()"
            [size]="'xs'"
          >
            <b>{{ 'core.no_permission.exit_from_app' | translate }}</b>
          </button>
        </p>
      </div>
    </div>
  </div>
}
